export default {
  init() {
    // JavaScript to be fired on all pages
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
    $(".toggleable a").on("click", function (event) {
      console.log("toggleable");
      if (event.target.href.includes("#")) {
        event.preventDefault();
        event.stopPropagation();
        if ($(this).parent().hasClass("active")) {
          $(this).parent().removeClass("active");
        } else {
          $(".toggleable").each(function () {
            $(this).removeClass("active");
          });
          $(this).parent().addClass("active");
          $("html").bind("click", function (e) {
            $(".toggleable").each(function () {
              $(this).removeClass("active");
            });
            $("html").unbind("click");
          });
        }
      }
    });
    if ($(".hp-testimonial").length > 0) {
      console.log("testimonials");
      // my slick slider options
      var options = {
        slidesToShow: 2,
        slidesToScroll: 2,
        dots: true,
        appendArrows: $(".controls-container.testimonial"),

        appendDots: $(".controls-container.testimonial .dots"),
        adaptiveHeight: true,
        responsive: [
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ],
      };

      // my slick slider as constant object
      const mySlider = $(".hp-testimonial")
        .on("init", function (slick) {
          // on init run our multi slide adaptive height function
          multiSlideAdaptiveHeight(this);
        })
        .on("beforeChange", function (slick, currentSlide, nextSlide) {
          // on beforeChange run our multi slide adaptive height function
          multiSlideAdaptiveHeight(this);
        })
        .slick(options);

      // our multi slide adaptive height function passing slider object
      function multiSlideAdaptiveHeight(slider) {
        // set our vars
        let activeSlides = [];
        let tallestSlide = 0;

        // very short delay in order for us get the correct active slides
        setTimeout(function () {
          // loop through each active slide for our current slider
          $(".slick-track .slick-active", slider).each(function (item) {
            // add current active slide height to our active slides array
            activeSlides[item] = $(this).outerHeight();
          });

          // for each of the active slides heights
          activeSlides.forEach(function (item) {
            // if current active slide height is greater than tallest slide height
            if (item > tallestSlide) {
              // override tallest slide height to current active slide height
              tallestSlide = item;
            }
          });

          // set the current slider slick list height to current active tallest slide height
          $(".slick-list", slider).height(tallestSlide);
        }, 10);
      }

      // when window is resized
      $(window).on("resize", function () {
        // run our multi slide adaptive height function incase current slider active slides change height responsively
        multiSlideAdaptiveHeight(mySlider);
      });
    }
    if ($(".logos-slider").length > 0) {
      console.log("logo slider");
      $(".logos-slider").slick({
        slidesToShow: 8,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 4,
            },
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3,
            },
          },
        ],
      });
    }
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js